<!--
<div class="d-flex" id="wrapper">
  <div
    class="navbar-light bg-light border-right"
    id="sidebar-wrapper"
    *ngIf="menu && menu.length > 0"
  >
    <div class="sidebar-heading">{{ fecdia }}</div>
    <div class="list-group list-group-flush">
      <a
        class="list-group-item list-group-item-action bg-light"
        [routerLink]="mnu.ruta"
        *ngFor="let mnu of menu; let i = index"
      >
        <fa-icon [icon]="mnu.icono"></fa-icon>
        {{ mnu.nombre }}
      </a>
    </div>
  </div>
  <div id="page-content-wrapper">
    <nav class="navbar navbar-expand-lg navbar-light bg-cave border-bottom">
      <button class="btn btn-light" (click)="persiana()" id="menu-toggle">
        <span class="navbar-toggler-icon"></span>
      </button>
      <span class="usuario">{{ nomusu }} </span>
    </nav>
  -->
<div class="container text-center mt-5">
  <h2 class="mb-4">Gestión de Entregas</h2>
  <p class="text-muted">Elige la opción que deseas realizar</p>

  <div class="row justify-content-center mt-4">
    <!-- Opción: Hacer pedido -->
    <div class="col-12 col-md-5 mb-3">
      <div class="card shadow p-4 opcion-card" (click)="irA('entregas')">
        <fa-icon [icon]="icoTra" size="2x"></fa-icon>
        <h4 class="mt-3">Hacer Pedido</h4>
        <p class="text-muted">Realizar un nuevo pedido de corderos</p>
      </div>
    </div>

    <!-- Opción: Listar pedidos -->
    <div class="col-12 col-md-5 mb-3">
      <div class="card shadow p-4 opcion-card" (click)="irA('entregalis')">
        <fa-icon [icon]="icoFac" size="2x"></fa-icon>
        <h4 class="mt-3">Mis Pedidos</h4>
        <p class="text-muted">Consultar los pedidos realizados</p>
      </div>
    </div>
  </div>
</div>
<!--
  </div>
</div>
-->
